import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { format as formatDate } from "date-fns";
import resources from "./en-US.json";

i18n.use(initReactI18next).init({
  lng: "en-US",
  defaultNS: "default",

  interpolation: {
    escapeValue: false,

    format: function (value, format) {
      if (value instanceof Date && format) {
        return formatDate(value, format);
      }

      return value;
    },
  },
});

i18n.addResourceBundle("en-US", "default", resources);

export default i18n;
